import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { SalesProcessNote } from '@app/models/sales-process-note';
import { MaterialModule } from '@app/shared/material.module';
import { SalesProcessToolAction } from '@app/shared/store/sales-process-tool/sales-process-tool.actions';

@Component({
  selector: 'app-sales-process-note',
  standalone: true,
	imports: [CommonModule, MaterialModule],
  templateUrl: './sales-process-note.component.html',
  styleUrls: ['./sales-process-note.component.scss']
})
export class SalesProcessNoteComponent implements OnInit {
  @Input() public note!: SalesProcessNote;
  
  constructor(private readonly store: Store) {}

  ngOnInit(): void { }

  protected onToggle(): void {
    this.store.dispatch(new SalesProcessToolAction.ToggleNoteRead(this.note.id));
  }
}
